import { STORYBOARD_TYPES } from "constants/storyboardType";

export const getStoryboardType = (name) => {
  switch (name) {
    case 'LANDING_PAGE':
      return 'Landing Page';
    case STORYBOARD_TYPES.INTERACTIVE_CONTENT:
    case STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2:
      return 'Interactive Content';
    case 'RESOURCE_CENTER':
      return 'Resource Center';
    case 'SPATIAL':
      return 'Spatial';
    case STORYBOARD_TYPES.FLIP_BOOK:
      return 'Flipbook'
    default:
      return name;
  }
};

export const getStoryboardMixpanelEventPayload = (id, name, type) => {
  if(id && name && type){
    return {
      'storyboard_id': id,
      'storyboard_name': name,
      'storyboard_content_type': getStoryboardType(type),
    }
  }else {
    return {}
  }
}

export const getPageViewedEventPayload = (screen_name, id, name, type) => {
  const basePayload = {
    screen_name: screen_name,
  };

  if (id && name && type) {
    return {
      ...basePayload,
      storyboard_id: id,
      storyboard_name: name,
      storyboard_content_type: getStoryboardType(type),
    };
  }

  if (id && name) {
    return {
      ...basePayload,
      workspace_id: id,
      workspace_name: name,
    };
  }

  return basePayload;
};

  
  export const getCustomFieldType = (name) => {
    switch (name) {
      case 'list_field':
        return 'List';
      case 'string_field':
        return 'Text';
      case 'number_field':
        return 'Number';
      case 'boolean_field':
        return 'Decision Box';
      default:
        return name;
    }
  }

  export const buildMixpanelPayload = (target, basePayload = {}) => {
    const mixpanelKeyMap = {
      trackProps: 'Clicked',
      widgetType: 'widget_type',
      customVariable: 'default_variable',
      trackSource: 'source',
      trackType: 'sort_type',
      trackOrder: 'sort_order',
      trackId: 'personalization_id',
      trackPage: 'page_id',
      trackAlias: 'alias_id',
      filterType: 'filter_type',
      variableId: 'variable_id',
      variableName: 'variable_name',
      variableType: 'variable_type',
    };

    const mixpanelPayload = Object.entries(mixpanelKeyMap).reduce((payload, [datasetKey, mixpanelKey]) => {
      const value = target?.dataset?.[datasetKey];
      if (value !== undefined) {
        payload[mixpanelKey] = value;
      }
      return payload;
    }, {});

    return {
      ...basePayload,
      ...mixpanelPayload,
    };
  };
